import { render, staticRenderFns } from "./MessagesContainer.vue?vue&type=template&id=a81bfeaa&scoped=true&"
import script from "./MessagesContainer.vue?vue&type=script&lang=js&"
export * from "./MessagesContainer.vue?vue&type=script&lang=js&"
import style0 from "./MessagesContainer.vue?vue&type=style&index=0&id=a81bfeaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81bfeaa",
  null
  
)

export default component.exports